import {
  types,
  IGetCapabilitiesAction,
  IGetCapabilitiesSuccessAction,
  IFailureAction,
} from '../types/capabilties'
import { ICapability } from '../types/capability'

export const getCapabilities = (): IGetCapabilitiesAction => ({
  type: types.GET_CAPABILITIES__STARTED,
})

export const getCapabilitiesSuccess = (
  list: ICapability[]
): IGetCapabilitiesSuccessAction => ({
  type: types.GET_CAPABILITIES__SUCCESS,
  list,
})

export const getCapabilitiesFailure = (message: string): IFailureAction => ({
  type: types.GET_CAPABILITIES__FAILURE,
  message,
})
